import { makeStyles } from '@material-ui/core/styles';

// SelectableCell zeroes the cell's padding and pads its link 4px 18px instead, so the header and
// the no-permission cells pad the same way. Otherwise the header sits 10px left of the values.
const cellPadding = (theme) => theme.spacing(1, 4.5);

const styles = (theme) => ({
  headerCell: {
    padding: cellPadding(theme),
    fontSize: 14,
    lineHeight: '20px'
  },
  cell: {
    padding: cellPadding(theme)
  },
  // One line per row: a long address is cut off here, with the full address as a tooltip.
  address: {
    display: 'block',
    maxWidth: 292,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  offer: {
    display: 'inline-flex',
    alignItems: 'center',
    whiteSpace: 'nowrap'
  },
  product: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(1)
  },
  productIcon: {
    width: 32,
    height: 32
  },
  plus: {
    margin: theme.spacing(0, 2),
    fontSize: 14,
    color: theme.colors.text_secondary
  },
  price: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 2
  },
  term: {
    fontSize: 10,
    lineHeight: '12px',
    textTransform: 'uppercase',
    color: theme.colors.text_secondary
  },
  noPrice: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    marginLeft: theme.spacing(2)
  },
  rep: {
    whiteSpace: 'nowrap'
  },
  updated: {
    fontSize: 12,
    lineHeight: '16px',
    whiteSpace: 'nowrap'
  }
});

export default makeStyles(styles);
